import { render, staticRenderFns } from "./testingButton.vue?vue&type=template&id=19935f89&"
import script from "./testingButton.vue?vue&type=script&lang=js&"
export * from "./testingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports